// src/encounter/lib/rail-date.ts
//
// `?x=rail-fixes` (Andrew, 4 Nov: "in the left panel, please remove the time from all the dates"): the one date formatter for the
// left rail. A date only, never a time of day, on the clinic's calendar in D-45 ("31 Mar 2026"), the same day `clinicDateTimeD45`
// would print before its time. Display only: the stored values are untouched. A server instant without an offset is UTC, as the
// rail's other readers take it. Every rail date that printed a time goes through here (today: the Device data "Last sync").
import { clinicDateD45 } from '@/shared/lib/clinic-time';

/** "31 Mar 2026" for an ISO date or instant; '' for a missing or broken one. */
export function railDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const instant = iso.length === 10 || /(Z|[+-]\d{2}:?\d{2})$/i.test(iso) ? iso : `${iso}Z`;
  return clinicDateD45(instant) ?? '';
}
